<template>
  <div class="loginWrapper">
    <!------------HTML Containers------------>
    <div
      class="container-fluid loginPageContainer"
      id="content-container"
      :style="loginImage"
    >
      <div class="row loginRow">
        <div class="col-md-4 marginLeft">
          <!------------Page Head---------------->
          <div class="pageHead">
            <h3>
              Interactive
              <b>Research</b>
            </h3>
          </div>
          <!---------Login Form---------------->
          <div class="loginContainer shadow-lg p-3 mb-5 rounded">
            <!----Title------------>
            <h3>Members Log in</h3>
            <hr />
            <!-----Login Fields----->
            <!--Login Error Message-->
            <form @submit.prevent="onLogin">
              <div class="row m-0" v-if="clienterrors">
                <div class="col-md-12 text-center">
                  <p class="m-0 text-danger" v-if="serverError.length > 0">
                    {{ serverError }}
                  </p>
                  <p
                    class="form-errors m-0"
                    v-for="error in clienterrors"
                    :key="error"
                  >
                    <span class="loginError">{{ error }}</span>
                  </p>
                </div>
                <div class="col-md-12">
                  <ul class="form-errors hide">
                    <p class="loginError"></p>
                  </ul>
                  <!--username-->
                  <div class="input-group mb-3">
                    <div class="input-group-prepend">
                      <img :src="usernameimg" class="input-group-text" />
                    </div>
                    <input
                      type="text"
                      class="form-control"
                      maxlength="32"
                      v-model="user.username"
                      v-on:input="formValidationHandler('user', 'username')"
                      placeholder="Username"
                      required
                    />
                  </div>
                  <div style="clear:both;"></div>
                  <!--password-->
                  <div class="input-group mb-3">
                    <div class="input-group-prepend">
                      <img :src="passwordimg" class="input-group-text" />
                    </div>
                    <input
                      type="password"
                      maxlength="20"
                      class="form-control"
                      v-model="user.password"
                      v-on:input="formValidationHandler('user', 'password')"
                      placeholder="Password"
                      required
                    />
                  </div>
                  <div style="clear:both;"></div>
                </div>
                <div class="col-md-12">
                  <div class="custom-control custom-checkbox float-left">
                    <input
                      type="checkbox"
                      class="custom-control-input"
                      id="customCheck"
                      name="remember"
                    />
                    <label class="custom-control-label" for="customCheck">
                      <small>Remember me?</small>
                    </label>
                  </div>
                  <!--Forgot Password-->
                  <div class="pswdBtn float-right">
                    <a href="#" @click="forgotPswdModalToggleHandler"
                      >Forgot Password</a
                    >
                  </div>
                </div>
              </div>
              <div style="clear:both;"></div>
              <!--Log In-->
              <div class="btnContainer text-center">
                <button class="btn submit" type="submit">
                  Login
                </button>
                <br />
                <span class="userReg">
                  New User?
                  <router-link
                    to="/userRegistration"
                    v-slot="{ href, navigate }"
                  >
                    <a :href="href" @click="navigate">Register Here</a>
                  </router-link>
                </span>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <!--------------Forgot Password Modal-------------------->
    <!-- <p class="hemant">{{ forgotPswdModalToggle }}</p> -->
    <div
      id="bulk_upload"
      v-if="forgotPswdModalToggle"
      class="chartsModalWrapper"
    >
      <!-- <div id="bulk_upload" class="chartsModalWrapper"> -->
      <div class="chart-modal-body">
        <div class="col-12 p-0 chartModalContainer">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title">Reset Password</h4>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
                @click="forgotPswdModalToggleHandler"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body p-0">
              <form @submit.prevent="forgotPswdFunc">
                <div class="emailForm m-0 border-bottom">
                  <div class="p-4">
                    <label for="emailAdd">Email:</label>
                    <b-form-input
                      id="email"
                      type="email"
                      maxlength="45"
                      v-model="form.email"
                      class="form-controlform-control"
                      autocomplete="off"
                      v-on:input="formValidationHandler('form', 'email')"
                    ></b-form-input>
                    <small class="field-text is-danger errorText">{{
                      errors.email
                    }}</small>
                  </div>
                </div>
                <div class="col-12 py-3 text-right">
                  <button type="submit" class="btn btn-primary">
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      id="forgotPswdModal"
      v-if="forgotPswdModalToggle"
      hide-footer
      size="md"
      centered
    >
      <div class="d-block text-center">
        <br />

        <input
          type="submit"
          value="Submit"
          class="btn btn-success otpBtn"
          id="otpBtn"
          @click="forgotPswdFunc()"
        />
        <br />
      </div>
    </b-modal>

    <!-- <div class="modal" id="infoModal" v-if="infoModalToggle">
      <div class="modal-dialog modal-md modal-dialog-centered fadeIn">
        <div class="modal-content"> -->
    <!-- Modal Header -->
    <!-- <div class="modal-header">
            <h4 class="modal-title">Reset Password</h4>
            <button
              type="button"
              class="close"
              id="infoClose"
              @click="closeInfoModal"
            >
              &times;
            </button>
          </div> -->
    <!-- Modal body -->
    <!-- <div class="modal-body">
            <p>
              An auto generated link has been shared on your email, please check
              for verification.
            </p>
          </div> -->
    <!-- </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import jquery from "jquery";
//Import Images
import bgImage from "@/assets/img/dbTiles/login.png";
import usernameimg from "@/assets/img/icons/username.png";
import passwordimg from "@/assets/img/icons/password.png";
import { userInputValidation } from "@/helpers/form-validation.js";
export default {
  name: "Login",
  data() {
    return {
      user: {
        username: "",
        password: "",
      },
      usernameimg: usernameimg,
      passwordimg: passwordimg,
      messages: [],
      loginImage: {
        backgroundImage: "url(" + bgImage + ")",
      },
      clienterrors: [],
      valid: true,
      errors: [],
      form: {
        email: "",
      },
      infoModalToggle: false,
      forgotPswdModalToggle: false,
    };
  },
  computed: {
    ...mapGetters(["getErrors"]),
    serverError() {
      return this.getErrors;
    },
  },
  mounted() {
    this.$store.commit("SET_ERROR", "");
  },
  methods: {
    ...mapActions(["login", "forgotPassword"]),
    userInputValidation,
    formValidationHandler(user, val) {
      let les = this.userInputValidation(this[user][val]);
      this[user][val] = "";
      this[user][val] = les;
      // console.log("----------", les);
    },
    async onLogin() {
      this.clienterrors = [];
      this.$store.commit("SET_ERROR", "");
      if (this.user.username == "") {
        this.clienterrors.push("Username require!");
      } else {
        let username = this.userInputValidation(this.user.username);
        let val = this.validateUsername(username);
        if (!val.valid) {
          this.clienterrors.push(val.error);
        }
      }
      if (this.user.password == "") {
        this.clienterrors.push("Password require!");
      }
      if (this.clienterrors.length === 0) {
        await this.login(this.user);
      }
    },
    // validate username
    validateUsername(username) {
      /** Blank check*/
      if (username.length <= 1)
        return { valid: false, error: "This field is required." };
      if (username.length < 6)
        return { valid: false, error: "Minimum 6 cheracter required." };
      /** Length check*/
      /** Format- Only characters,digits,. and _ check*/
      let usernameRegEx = /^[a-zA-Z0-9._]*$/;
      if (usernameRegEx.test(username) == false) {
        return {
          valid: false,
          error: "Please enter valid username.",
        };
      }
      return { valid: true, error: null };
    },
    // forgot password email input reset, and modal toggle
    forgotPswdModalToggleHandler() {
      this.form.email = "";
      this.forgotPswdModalToggle = !this.forgotPswdModalToggle;
    },
    // closeForgotPswdModal() {
    //   jquery("#forgotPswdModal").hide();
    //   jquery("#errMsg_emailAdd").empty();
    //   jquery("#emailAdd").val("");
    //   jquery(".close").attr("data-dismiss", "modal");
    // },
    // closeInfoModal() {
    //   jquery(".close").attr("data-dismiss", "modal");
    //   jquery(".modal-backdrop.show").hide();
    //   // jquery("#infoModal").hide();
    //   this.infoModalToggle = false;
    // },
    validateEmail(email) {
      //Blank
      /** Blank */
      if (!email.length)
        return { valid: false, error: "This field is required" };
      /** Formatting */
      if (!email.match(/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(.\w{2,3})+$/))
        return { valid: false, error: "Please, enter a valid email." };

      return { valid: true, error: null };
    },
    async forgotPswdFunc() {
      this.clienterrors = {};
      // let email = jquery("#emailAdd").val();
      let email = this.form.email;
      // console.log(email);
      //------------------Validate Email Address---------
      const validEmail = this.validateEmail(this.form.email);
      // console.log("this.form.email", this.form.email, "validEmail", validEmail);
      this.valid = validEmail.valid;
      //-----Submit Form----------
      if (this.valid == true) {
        let obj = {
          email,
        };
        let responce = await this.forgotPassword(obj);
        // console.log("responce++++++Login", responce);
        this.infoModalToggle = true;
        if (responce.status == 200 || responce.status == 201) {
          this.forgotPswdModalToggleHandler();
        }
        // this.form.email = "";
      } else {
        alert(validEmail.error);
      }
    },
  },
};
</script>

<style lang="scss">
/*********************Page Background************************/
.loginWrapper {
  height: 100%;
}

.loginPageContainer {
  position: relative;
  background-size: cover;
  overflow: hidden;
  height: 100%;
  width: 100%;
}

/**********************Login Container***************************/

.loginRow {
  margin-top: 9rem !important;
  position: relative;
  height: 78%;
}

.col-md-4 {
  height: 100%;
}

.marginLeft {
  margin-left: 10rem !important;
}

.pageHead h3 {
  color: $color-white;
  text-align: center;
  font-size: 35px;
}

.loginContainer:before {
  position: absolute;
  content: "";
  display: block;
  width: 0;
  height: 0;
  left: 50%;
  margin-left: -20px;
  margin-top: -65px;
  border: 20px solid transparent;
  border-bottom: 30px solid rgb(236, 236, 236);
}

.loginError {
  color: $color-red;
  font-size: 12px;
  left: 0;
  margin-bottom: 0 !important;
}

/**********************Login Form***************************/

.loginContainer {
  .col-md-12 {
    padding: 0 15px !important;
  }

  h3 {
    text-align: center;
    font-size: 20px;
    /* line-height: 200px; */
    color: $color-dark-grey;
    font-family: "Arial";
  }

  hr {
    width: 252px;
    height: 1px;
    filter: drop-shadow(0px 1px 0px $color-white);
    background-color: #acacac;
  }

  margin: 70px auto;
  width: 293px;
  min-height: 283px;
  background-image: linear-gradient(0deg, #cccccc 0%, #ffffff 100%);
  border: 1px solid rgba(158, 158, 158, 0.4);
}

.input-group > .custom-file,
.input-group > .custom-select,
.input-group > .form-control,
.input-group > .form-control-plaintext {
  width: 154px;
  height: 29px;
  font-size: 12px;
  color: #494848 !important;
  font-family: "Arial";
}

.form-control img {
  width: 12px;
  height: 14px;
}

/*--------------Forgot Password--------------*/

.pswdBtn {
  position: relative;
  width: 93px;
  height: 18px;
  font-size: 11px;
  line-height: 26px;
  color: #6d6d6d;
  font-family: "Arial";
}

.pswdBtn a,
.pswdBtn span {
  color: $color-dark-grey;
  text-decoration: none;
  font-size: 10px;
  font-weight: normal;
  text-transform: capitalize;
}

.pswdBtn a:hover,
.userReg a:hover {
  font-weight: bold;
  color: $base-color;
}

/*--------------Submit--------------*/

.btnContainer {
  line-height: 2;
}

.submit {
  width: 113px;
  height: 29px;
  filter: drop-shadow(0px 1px 2px rgba(0, 0, 0, 0.3));
  border: 1px solid;
  font-size: 14px;
  color: #4d4d4d;
  font-family: "Arial";
  text-align: center;
  filter: drop-shadow(0px 1px 2px rgba(0, 0, 0, 0.3));
  background-color: #a9aaab !important;
  border-color: #a9aaab !important;
  line-height: 1 !important;
}

.box-shadow--2dp {
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.2),
    0 1px 5px 0 rgba(0, 0, 0, 0.12);
}

.userReg {
  width: 141px;
  height: 18px;
  font-size: 11px;
  color: #6d6d6d;
  font-family: "Arial";
}

.userReg a {
  color: $base-grey;
  text-decoration: underline;
}

/*--------------Checkbox--------------*/

.custom-control-label {
  width: 93px;
  height: 18px;
  font-size: 11px;
  line-height: 26px;
  color: #6d6d6d;
}

.checkboxContainer {
  position: relative;
  cursor: pointer;
  font-size: 1.6vh;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Hide the browser's default checkbox */

.checkboxContainer input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */

.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 15px;
  width: 15px;
  background-color: $base-color;
  border-radius: 2px;
}

/* On mouse-over, add a grey background color */

.checkboxContainer:hover input ~ .checkmark {
  background-color: $base-color;
}

/* When the checkbox is checked, add a blue background */

.checkboxContainer input:checked ~ .checkmark {
  background-color: $base-color;
}

/* Create the checkmark/indicator (hidden when not checked) */

.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */

.checkboxContainer input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */

.checkboxContainer .checkmark:after {
  left: 5px;
  top: 2px;
  width: 5px;
  height: 10px;
  border: solid $color-white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}

small {
  font-size: 100%;
}

/*******************Logout**********************/

.logoutText {
  position: relative;
  margin-top: 20%;
  color: #000;
  font-size: 2.3 vh;
  font-family: sans-serif;
}

.logoutText a,
.logoutText span {
  font-weight: bold;
  color: $base-color;
}

.logoutTitle {
  font-weight: normal;
  font-size: 5vh;
  color: $color-dark-grey;
}

/************Forgot Password Modal*******************/

.modal-title {
  text-align: center;
  left: 0;
  width: 100%;
}

.modal-body p {
  font-size: 13px;
  color: $color-green;
  padding-bottom: 10px;
  margin-top: 20px;
  margin-left: 12px;
  font-weight: 600;
}

.emailForm {
  margin: 1rem;
}

.emailForm label {
  font-weight: 600;
  font-size: 12px;
  position: relative;
  display: inline-block;
}

.emailForm input {
  font-size: 12px;
  position: relative;
  display: inline-block;
  width: 60%;
  margin-left: 5px;
}

.otpBtn {
  position: relative;
  cursor: pointer;
  padding: 5px 25px;
  left: 40%;
}
.input-group-text {
  padding: 0.65rem 0.75rem !important;
}
</style>
